import { useMemo } from "react"

interface UseCountdownTimerOptions {
  startMinutes: number
}

interface UseCountdownTimerReturn {
  endTime: number
}

export default function useCountdownTimer({
  startMinutes,
}: UseCountdownTimerOptions): UseCountdownTimerReturn {
  const endTime = useMemo(
    () => Date.now() + startMinutes * 60 * 1000,
    [startMinutes],
  )

  return { endTime }
}
